export const withoutLayoutThemePath = [
  "/pages/errors/error400",
  "/pages/errors/error401",
  "/pages/errors/error403",
  "/pages/errors/error404",
  "/pages/errors/error500",
  "/pages/errors/error503",
  "/pages/comingsoon/comingsoonsimple",
  "/pages/comingsoon/coming-bg-video",
  "/pages/comingsoon/coming-bg-img",
  "/pages/authentication/login-simple",
  "/pages/authentication/login-bg-img",
  "/pages/authentication/login-img",
  "/pages/authentication/login-validation",
  "/pages/authentication/login-tooltip",
  "/pages/authentication/login-sweetalert",
  "/pages/authentication/registerwizard",
  "/pages/authentication/register-simple",
  "/pages/authentication/register-bg-img",
  "/pages/authentication/sign-up-two",
  "/pages/authentication/unlock-user",
  "/pages/authentication/forget-pwd",
  "/pages/authentication/create-pwd",
  "/pages/authentication/maintenance",
  "/authentication/login",
  "/authentication/register-siswa",
  "/authentication/register-pendamping",
  "/authentication/register-mahasiswa",
  "/no_access",
  "/authentication/satu_login",
  "/kotak_surat",
];


export const stepperHorizontalData = [
  { tittle: "personal", detail: "Add personal details" },
  { tittle: "Address", detail: "Add additional info" },
  { tittle: "Message", detail: "Add message(optional)" },
  { tittle: "Done", detail: "Complete.. !" },
];